/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PhotoStatus = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetailsBio_seller = {
    readonly serviceId: string | null;
    readonly isRewardsTier2: boolean | null;
    readonly liveStorefrontProfile: {
        readonly aboutUsUnbranded: string | null;
        readonly headshots: ReadonlyArray<{
            readonly status: PhotoStatus | null;
            readonly path: string | null;
        } | null> | null;
        readonly galleryAlbum: {
            readonly mediaList: ReadonlyArray<{
                readonly sortOrder: string | null;
                readonly element: {
                    readonly path?: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "PdpRespDealerDetailsBio_seller";
};
export type PdpRespDealerDetailsBio_seller$data = PdpRespDealerDetailsBio_seller;
export type PdpRespDealerDetailsBio_seller$key = {
    readonly " $data"?: PdpRespDealerDetailsBio_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetailsBio_seller">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespDealerDetailsBio_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "isRewardsTier2",
      "name": "isAnchorListMember",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "liveStorefrontProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "aboutUsUnbranded",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": "headshots",
          "name": "photos",
          "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")",
          "args": [
            {
              "kind": "Literal",
              "name": "photoType",
              "value": "DEALER_STOREFRONT_HEADSHOT"
            }
          ],
          "concreteType": "Photo",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "galleryAlbum",
          "storageKey": null,
          "args": null,
          "concreteType": "MediaAlbum",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaList",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaElement",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "sortOrder",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "element",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "type": "Photo",
                      "selections": [
                        (v0/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'b1e95cce4422ae2a64a433681d64ccef';
export default node;
